import Panels from './Panels.jsx';

export default Panels;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/FilterGroupCollection/Panels/index.js